import { LoadingStates } from '@pb/utils'
import { mergeDeepRight } from 'ramda'
import { createReducer } from 'redux-act'

import { KlarnaState, MemberInfo } from '../types'
import * as actions from './actions'
import initialState from './initialState'

const setMemberInfo = (state, memberInfo: MemberInfo): KlarnaState => ({
  ...state,
  memberInfo: {
    ...state.memberInfo,
    ...memberInfo,
  },
})

const setPaymentsLoadStatus = (state, { paymentMethodCategory, ...response }): any =>
  mergeDeepRight(state, {
    payments: {
      paymentMethodCategory: {
        [paymentMethodCategory]: { ...response, loadStatus: LoadingStates.LoadedSuccess },
      },
    },
  })

const setPaymentsAuthStart = (state): any => ({
  ...state,
  payments: {
    ...state.payments,
    authStatus: LoadingStates.Loading,
  },
})

const setPaymentsAuthStatus = (state, { paymentMethodCategory, response }): any =>
  mergeDeepRight(state, {
    payments: {
      authStatus: LoadingStates.LoadedSuccess,
      paymentMethodCategory: {
        [paymentMethodCategory]: { ...response },
      },
    },
  })

const setPaymentsInitStart = (state): any => ({
  ...state,
  payments: {
    ...state.payments,
    initStatus: LoadingStates.Loading,
    authStatus: LoadingStates.NotLoaded,
    paymentMethodCategory: {},
  },
})

const setPaymentsInitSuccess = (state): any => ({
  ...state,
  payments: {
    ...state.payments,
    initStatus: LoadingStates.LoadedSuccess,
    authStatus: LoadingStates.NotLoaded,
    paymentMethodCategory: {},
  },
})

const setPaymentsInitFail = (state): any => ({
  ...state,
  payments: {
    ...state.payments,
    initStatus: LoadingStates.LoadedFail,
    authStatus: LoadingStates.NotLoaded,
    paymentMethodCategory: {},
  },
})

const fetchStoreActivationSessionStart = (state): any => ({
  ...state,
  storeActivation: {
    ...state.storeActivation,
    sessionStatus: LoadingStates.Loading,
  },
})

const fetchStoreActivationSessionSuccess = (
  state,
  { klarnaSessionBody, paymentMethodCategory },
): any => ({
  ...state,
  storeActivation: {
    ...state.storeActivation,
    sessionStatus: LoadingStates.LoadedSuccess,
    paymentMethodCategory,
    klarnaSessionBody,
  },
})

const storeActivationFail = (state): any => ({
  ...state,
  storeActivation: {
    ...state.storeActivation,
    sessionStatus: LoadingStates.LoadedFail,
  },
})

const fetchStoreActivationInfoStart = (state): any => ({
  ...state,
  storeActivationInfo: {
    ...state.storeActivationInfo,
    status: LoadingStates.Loading,
  },
})
const fetchStoreActivationInfoSuccess = (state, storeActivationInfoLink): any => ({
  ...state,
  storeActivationInfo: {
    ...state.storeActivationInfo,
    status: LoadingStates.LoadedSuccess,
    storeActivationInfoLink,
  },
})
const fetchStoreActivationInfoFail = (state): any => ({
  ...state,
  storeActivationInfo: {
    ...state.storeActivationInfo,
    status: LoadingStates.LoadedFail,
  },
})

export default createReducer((on) => {
  on(actions.setMemberInfo, setMemberInfo)
  on(actions.setPaymentsInitStart, setPaymentsInitStart)
  on(actions.setPaymentsInitSuccess, setPaymentsInitSuccess)
  on(actions.setPaymentsInitFail, setPaymentsInitFail)
  on(actions.setPaymentsLoadStatus, setPaymentsLoadStatus)
  on(actions.setPaymentsAuthStatus, setPaymentsAuthStatus)
  on(actions.setPaymentsAuthStart, setPaymentsAuthStart)
  on(actions.fetchStoreActivationSessionStart, fetchStoreActivationSessionStart)
  on(actions.fetchStoreActivationSessionSuccess, fetchStoreActivationSessionSuccess)
  on(actions.storeActivationFail, storeActivationFail)
  on(actions.fetchStoreActivationInfoStart, fetchStoreActivationInfoStart)
  on(actions.fetchStoreActivationInfoSuccess, fetchStoreActivationInfoSuccess)
  on(actions.fetchStoreActivationInfoFail, fetchStoreActivationInfoFail)
}, initialState)
